"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _recompose = require("recompose");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Stylegator = function Stylegator(_ref) {
  var basename = _ref.basename,
      logo = _ref.logo,
      partials = _ref.partials,
      sections = _ref.sections,
      browserRouter = _ref.browserRouter;
  var Layout = partials.Layout;
  var RouterComponent = browserRouter ? _reactRouterDom.BrowserRouter : _reactRouterDom.HashRouter;
  return _react["default"].createElement(RouterComponent, {
    basename: basename
  }, _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(Layout, {
    logo: logo
  }, (0, _utils.buildRoutes)((0, _utils.setSlugs)(sections)))));
};

Stylegator.propTypes = {
  basename: _propTypes["default"].string,
  components: _propTypes["default"].shape({}),
  logo: _propTypes["default"].string,
  partials: _utils.partialsPropTypes,
  sections: _propTypes["default"].array,
  theme: _propTypes["default"].shape({}),
  browserRouter: _propTypes["default"].bool
};
Stylegator.defaultProps = {
  components: {},
  partials: (0, _utils.useCustomPartials)(),
  sections: [],
  theme: {},
  browserRouter: false
};

var _default = (0, _recompose.withContext)({
  components: _propTypes["default"].shape({}),
  partials: _utils.partialsPropTypes,
  sections: _propTypes["default"].array,
  theme: _propTypes["default"].shape({})
}, function (_ref2) {
  var _ref2$components = _ref2.components,
      components = _ref2$components === void 0 ? {} : _ref2$components,
      _ref2$partials = _ref2.partials,
      partials = _ref2$partials === void 0 ? (0, _utils.useCustomPartials)() : _ref2$partials,
      _ref2$sections = _ref2.sections,
      sections = _ref2$sections === void 0 ? [] : _ref2$sections,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? {} : _ref2$theme,
      _ref2$browserRouter = _ref2.browserRouter,
      browserRouter = _ref2$browserRouter === void 0 ? false : _ref2$browserRouter;
  return {
    components: (0, _utils.makeGlobal)(components),
    partials: partials,
    sections: (0, _utils.setSlugs)(sections),
    theme: theme
  };
})(Stylegator);

exports["default"] = _default;